import constant from '../../../main.constants';

const TERMINAL = new Set([
    constant.FACE_JOB_STATUS.COMPLETED,
    constant.FACE_JOB_STATUS.FAILED,
    constant.FACE_JOB_STATUS.CANCELLED
]);

const VIDEO_TERMINAL = new Set([
    constant.FACE_VIDEO_JOB_STATUS.COMPLETED,
    constant.FACE_VIDEO_JOB_STATUS.FAILED,
    constant.FACE_VIDEO_JOB_STATUS.CANCELLED
]);

const getters = {
    isJobActive(state) {
        if (!state.currentJob) return false;
        return !TERMINAL.has(state.currentJob.status);
    },
    isJobTerminal(state) {
        if (!state.currentJob) return false;
        return TERMINAL.has(state.currentJob.status);
    },
    jobProgressPct(state) {
        const j = state.currentJob;
        if (!j || !j.fileCount) return 0;
        return Math.min(100, Math.round((j.processedCount / j.fileCount) * 100));
    },
    isVideoJobActive(state) {
        if (!state.videoCurrentUpload) return false;
        return !VIDEO_TERMINAL.has(state.videoCurrentUpload.status);
    },
    isVideoJobTerminal(state) {
        if (!state.videoCurrentUpload) return false;
        return VIDEO_TERMINAL.has(state.videoCurrentUpload.status);
    },
    videoJobProgressPct(state) {
        const j = state.videoCurrentUpload;
        if (!j || !j.totalFrames) return 0;
        return Math.min(100, Math.round((j.processedFrames / j.totalFrames) * 100));
    }
};

export default getters;
